import ModalConfirm from "./ModalConfirm.presenter";

export default ModalConfirm;
